module.exports = __webpack_public_path__ + "assets/header_logo_small.5442f4c4.svg";